import { useEffect, useState } from "react";
import { PageHeader } from "@/components/DashboardShell";
import { Stat } from "@/components/brand";
import api from "@/lib/api";

export default function MerchantBilling() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/deliveries"); setOrders(data); })(); }, []);

  const byMonth = {};
  orders.forEach((d) => {
    const k = new Date(d.created_at).toLocaleString("en-US", { month: "short", year: "numeric" });
    byMonth[k] = byMonth[k] || { count: 0, cost: 0 };
    byMonth[k].count += 1;
    byMonth[k].cost += d.cost || 0;
  });
  const total = orders.reduce((s, d) => s + (d.cost || 0), 0);

  return (
    <div>
      <PageHeader index="04" eyebrow="Billing" title="Billing & invoices" />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 border border-gray-200 p-6 mb-8">
        <Stat label="Total deliveries" value={orders.length} />
        <Stat label="Total billed" value={`$${total.toFixed(2)}`} />
        <Stat label="Avg / delivery" value={orders.length ? `$${(total / orders.length).toFixed(2)}` : "$0.00"} />
      </div>

      <div className="flex items-center gap-4 mb-4">
        <span className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400">By period</span>
        <span className="h-px flex-1 bg-gray-200" />
      </div>
      <div className="border border-gray-200 divide-y divide-gray-200" data-testid="billing-list">
        {Object.keys(byMonth).length === 0 && <div className="px-5 py-10 text-center text-sm text-gray-400">No billing activity.</div>}
        {Object.entries(byMonth).map(([month, v]) => (
          <div key={month} className="flex items-center justify-between px-5 py-4">
            <div>
              <div className="text-sm text-[#0a0a0a]">{month}</div>
              <div className="text-xs text-gray-500">{v.count} deliveries</div>
            </div>
            <div className="text-sm font-semibold text-[#0a0a0a]">${v.cost.toFixed(2)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
